// | An implementation of Storage that uses `local-storage-fallback`.
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import {getItem, setItem} from "./foreign.js";
const localStorageWithFallback = /* #__PURE__ */ Restaumatic$dServices$dStorage.$Storage(
  x => {
    const $0 = getItem(x);
    return () => {
      const a$p = $0();
      return Data$dNullable.nullable(a$p, Data$dMaybe.Nothing, Data$dMaybe.Just);
    };
  },
  setItem
);
export {localStorageWithFallback};
export * from "./foreign.js";
